// Public-facing Rendeavored destinations (return-to-home targets).
// Apex domain is canonical (no www, no trailing slash) until the www redirect is fixed.
export const HOME_URL = "https://rendeavored.com";
export const PRIVACY_URL = "https://rendeavored.com/privacy";

// Microsoft Bookings consultation link (future-proofed: swap here to update everywhere).
export const BOOKING_URL =
  "https://bookings.cloud.microsoft/bookwithme/user/9dac6e7364bf43bd9a4e29846448510c%40rendeavored.com?anonymous&ismsaljsauthenabled";

export const FOUNDER = {
  name: "RJ Mortero",
  title: "Founder & Managing Partner",
  company: "Rendeavored Group, LLC",
  email: "rj@rendeavored.com",
  website: HOME_URL,
};

// Estimate disclaimer shown across the public pricing experience.
export const PRICING_DISCLAIMER =
  "Estimates are provided for workforce planning purposes. Final pricing depends on role requirements, experience, schedule, scope, and implementation needs.";
